import { ContactDto } from 'gleblu-socket-api';

import Contact from '../interfaces/Contact';

export function fromDto(contactDto: ContactDto): Contact {
  const {
    uuid,
    placeUuid,
    name,
    uniqueName,
    street,
    number,
    cityRo,
    cityEn,
    cityHu,
    country,
    latitude,
    longitude,
    descriptionEn,
    descriptionHu,
    descriptionRo,
    phoneNumber,
    website,
    menu,
  } = contactDto;
  const formattedAddress = `${street} ${number}, ${cityRo}`;
  return {
    uuid,
    placeUuid,
    name,
    uniqueName,
    street,
    number,
    cityRo,
    cityEn,
    cityHu,
    country,
    descriptionEn,
    descriptionHu,
    descriptionRo,
    phoneNumber,
    website,
    menu,
    formattedAddress,
    geometry: { lat: latitude, lng: longitude },
  };
}

export function toDto(contact: Contact): ContactDto {
  const {
    uuid,
    placeUuid,
    name,
    uniqueName,
    street,
    number,
    cityRo,
    cityEn,
    cityHu,
    country,
    descriptionEn,
    descriptionHu,
    descriptionRo,
    phoneNumber,
    website,
    menu,
    geometry,
  } = contact;
  return {
    uuid,
    placeUuid,
    name,
    uniqueName,
    street,
    number,
    cityRo,
    cityEn,
    cityHu,
    country,
    descriptionEn,
    descriptionHu,
    descriptionRo,
    phoneNumber,
    website,
    menu,
    latitude: geometry.lat,
    longitude: geometry.lng,
  };
}
